// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shift-date-container {
  overflow-y: auto;
  .shift-date {
    width: 54px;
    height: 72px;
    border-radius: 16px;
    background-color: #e4f7e3;

    .shift-date-content {
      display: flex;
      width: 54px;
      flex-direction: column; /* Stack month and date vertically */
      align-items: center; /* Center horizontally */
      justify-content: center; /* Center vertically */

      .header {
        height: 12px;
        width: 8px;
      }
      .month {
        color: var(--Boulder, #7a7a7a);
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .date {
        color: var(--Dune, #262626);
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-bottom: 5px;
      }
      .needs-approval {
        width: 8px;
        height: 8px;
        .shift-date-needs-approval {
          width: 8px;
          height: 8px;
          background-color: #eca300;
          border-radius: 8px;
        }
      }
    }
  }
  .shift-empty-active-date {
    border-radius: var(--control-md-control-padding-md, 16px);
    border: 1.5px solid var(--Regent-Gray, #808b9d);
    background: #f1f3f5 !important;
    div > div {
      font-weight: 900 !important;
    }
  }
  .shift-active-date {
    border-radius: 16px;
    border: 1.5px solid #45a735;
    background: var(
      --gradient,
      linear-gradient(180deg, #eeffec 33.04%, #fff 117.86%)
    );
    div > div {
      font-weight: bold !important;
      color: #45a735 !important;
    }
  }
  .shift-empty-date {
    border-radius: var(--control-md-control-padding-md, 16px);
    background: #f4f5f7;
  }
}

.no-shifts-here {
  display: flex;
  flex-direction: column; /* Stack month and date vertically */
  align-items: center; /* Center horizontally */
  justify-content: center; /* Center vertically */
  height: 400px !important;

  .no-shifts-here-logo > img {
    width: 70px;
    height: 61px;
  }
  .no-shifts-here-heading {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .no-shifts-here-content {
    color: #7a7a7a;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.shift-date-container::-webkit-scrollbar {
  width: 0px;
}

.shift-date-container::-webkit-scrollbar-track {
  background: transparent;
}

.shift-date-container::-webkit-scrollbar-thumb {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/Dashboard/ShiftWeekList/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;;IAEzB;MACE,aAAa;MACb,WAAW;MACX,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB,EAAE,wBAAwB;MAC7C,uBAAuB,EAAE,sBAAsB;;MAE/C;QACE,YAAY;QACZ,UAAU;MACZ;MACA;QACE,8BAA8B;QAC9B,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,2BAA2B;QAC3B,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;MACrB;MACA;QACE,UAAU;QACV,WAAW;QACX;UACE,UAAU;UACV,WAAW;UACX,yBAAyB;UACzB,kBAAkB;QACpB;MACF;IACF;EACF;EACA;IACE,yDAAyD;IACzD,+CAA+C;IAC/C,8BAA8B;IAC9B;MACE,2BAA2B;IAC7B;EACF;EACA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B;;;KAGC;IACD;MACE,4BAA4B;MAC5B,yBAAyB;IAC3B;EACF;EACA;IACE,yDAAyD;IACzD,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,wBAAwB;EAC7C,uBAAuB,EAAE,sBAAsB;EAC/C,wBAAwB;;EAExB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".shift-date-container {\n  overflow-y: auto;\n  .shift-date {\n    width: 54px;\n    height: 72px;\n    border-radius: 16px;\n    background-color: #e4f7e3;\n\n    .shift-date-content {\n      display: flex;\n      width: 54px;\n      flex-direction: column; /* Stack month and date vertically */\n      align-items: center; /* Center horizontally */\n      justify-content: center; /* Center vertically */\n\n      .header {\n        height: 12px;\n        width: 8px;\n      }\n      .month {\n        color: var(--Boulder, #7a7a7a);\n        text-align: center;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n      .date {\n        color: var(--Dune, #262626);\n        text-align: center;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        padding-bottom: 5px;\n      }\n      .needs-approval {\n        width: 8px;\n        height: 8px;\n        .shift-date-needs-approval {\n          width: 8px;\n          height: 8px;\n          background-color: #eca300;\n          border-radius: 8px;\n        }\n      }\n    }\n  }\n  .shift-empty-active-date {\n    border-radius: var(--control-md-control-padding-md, 16px);\n    border: 1.5px solid var(--Regent-Gray, #808b9d);\n    background: #f1f3f5 !important;\n    div > div {\n      font-weight: 900 !important;\n    }\n  }\n  .shift-active-date {\n    border-radius: 16px;\n    border: 1.5px solid #45a735;\n    background: var(\n      --gradient,\n      linear-gradient(180deg, #eeffec 33.04%, #fff 117.86%)\n    );\n    div > div {\n      font-weight: bold !important;\n      color: #45a735 !important;\n    }\n  }\n  .shift-empty-date {\n    border-radius: var(--control-md-control-padding-md, 16px);\n    background: #f4f5f7;\n  }\n}\n\n.no-shifts-here {\n  display: flex;\n  flex-direction: column; /* Stack month and date vertically */\n  align-items: center; /* Center horizontally */\n  justify-content: center; /* Center vertically */\n  height: 400px !important;\n\n  .no-shifts-here-logo > img {\n    width: 70px;\n    height: 61px;\n  }\n  .no-shifts-here-heading {\n    color: #000;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .no-shifts-here-content {\n    color: #7a7a7a;\n    text-align: center;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.shift-date-container::-webkit-scrollbar {\n  width: 0px;\n}\n\n.shift-date-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.shift-date-container::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
